import script from "./AppNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./AppNavbar.vue?vue&type=style&index=0&id=c9623d9c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9623d9c"]])

export default __exports__